import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MessagingService } from '../../components/messaging/messaging.service';
import { EIO_DATE_UI_FORMAT_MOMENT } from '../../consts/localization.const';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { UnixDateFormatPipe } from '../../pipes/unixDateFormat.pipe';
import { NoticeService } from '../../services/notice.service';
import { NoticePromptView } from './notice.model';
import { NoticeMediaGalleryComponent } from './notice-media-gallery/notice-media-gallery.component';

@Component({
  selector: 'acknowledge-notice-modal',
  imports: [
    MatDialogModule,
    MatChipsModule,
    MatButtonModule,
    UnixDateFormatPipe,
    SafeHtmlPipe,
    NoticeMediaGalleryComponent
  ],
  template: `
    <div class="p-40">
      <div class="flex justify-between gap-10">
        <div class="text-[16px] font-semibold whitespace-normal break-words text-justify">
          {{ data.notices[currentNoticeIndex()]?.title }}
        </div>
        <mat-chip-option>
          {{ data.notices[currentNoticeIndex()]?.publishDate | unixDateFormat: dateFormat }}
        </mat-chip-option>
      </div>
      <mat-dialog-content class="overflow-hidden">
        <div
          class="overflow-auto custom-thin-scrollbar max-h-[600px] pr-10"
          [innerHTML]="data.notices[currentNoticeIndex()]?.body | safeHtml"></div>
        @if (data.notices[currentNoticeIndex()]?.medias?.length) {
          <notice-media-gallery class="mt-20" [medias]="data.notices[currentNoticeIndex()]?.medias" />
        }
        <div class="flex justify-center pt-10">
          @if (data.notices?.length > 1) {
            <mat-chip-option class="px-10">
              {{ currentNoticeIndex() + 1 }} of {{ data.notices.length }}
            </mat-chip-option>
          }
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="flex! justify-center! p-0!">
        <button matButton="elevated" class="red-button" (click)="acknowledgeNotice()">ACKNOWLEDGE</button>
      </mat-dialog-actions>
    </div>
  `
})
export class AcknowledgeNoticeModalComponent {
  #dialogRef = inject(MatDialogRef<AcknowledgeNoticeModalComponent>);
  #noticeService = inject(NoticeService);
  #messageService = inject(MessagingService);
  data: {
    notices: NoticePromptView[];
  } = inject(MAT_DIALOG_DATA);
  protected readonly dateFormat = EIO_DATE_UI_FORMAT_MOMENT;
  currentNoticeIndex = signal<number>(0);

  acknowledgeNotice() {
    this.#noticeService.acknowledgeNotice(this.data.notices[this.currentNoticeIndex()].id).subscribe({
      next: () => this.currentNoticeIndex.update((val) => val + 1),
      error: () => {
        this.#messageService.error('Could not acknowledge notice');
        this.#dialogRef.close();
      },
      complete: () => this.currentNoticeIndex() === this.data.notices?.length && this.#dialogRef.close()
    });
  }
}
